"use strict";
/* eslint-disable max-lines */
// Eslint doesn't know how to handle the Map from Immutable.
/* eslint-disable functional/prefer-readonly-type */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCurrentPromoDynamicDiscountCodes = exports.selectEvergreenPromoCodeWithMonitoring = exports.selectActivePromoCodeWithMonitoring = exports.selectCurrentPromoCodeWithMonitoring = exports.selectActivePromoFlag = exports.selectCurrentPromoFlag = exports.selectActivePromoVariationId = exports.selectCurrentPromoVariationId = exports.selectEvergreenPromoCode = exports.selectPartnerPromoCodes = exports.selectActivePromoCode = exports.selectCurrentPromoCode = exports.selectMonthsOfServiceDisplay = exports.selectMonthsOfService = exports.selectMonthsOfFreeService = exports.selectTopBannerVisible = exports.selectCurrentPromoTopBannerVisible = exports.selectParsedEvergreenPromotion = exports.selectParsedActivePromotion = exports.selectParsedCurrentPromotion = exports.selectIsActivePromotion = exports.selectCurrencyCode = exports.selectLocale = exports.selectPackagesDiscountDisplayText = exports.selectPackageDiscountWithMonitoringDisplayText = exports.selectPackageDiscountDisplayText = exports.selectPackageListPrice = exports.selectPackageDisplayPrice = exports.selectContactSubmitResponse = exports.selectGeoLocationPlace = exports.selectCrimesByCategory = exports.selectCartLineItemNames = exports.selectCartHasOnlyCameras = exports.selectCartHasPackage = exports.selectCartId = exports.selectCartCount = exports.selectCart = exports.selectMiniCart = exports.selectCustomSystemDiscountedPrice = exports.selectCustomSystemTotalPrice = exports.selectPackageDiscountValues = exports.selectMiniCartLineItems = exports.selectAllPackageSkus = exports.liftSelectPackage = exports.selectPackage = exports.selectHiddenProductSkus = exports.selectProducts = exports.liftSelectProduct = exports.selectProduct = exports.selectNavigationProductCategory = void 0;
exports.selectHeroStickerImage = exports.selectCurrentPromotionMobileBannerImage = exports.selectPartnerWithUsSubmit = exports.selectItemsFromSkus = exports.selectItemFromSku = exports.selectDisplayMonitoringDiscount = exports.selectCurrentPromoDisplayMonitoringDiscount = exports.selectEvergreenPromoLastModifiedTime = exports.selectActivePromoLastModifiedTime = exports.selectCurrentPromoLastModifiedTime = exports.selectEvergreenPromoLastFetchedTime = exports.selectActivePromoLastFetchedTime = exports.selectCurrentPromoLastFetchedTime = exports.selectActivePromoLoading = exports.selectCurrentPromoLoading = exports.selectPromotionBanner = exports.selectCurrentPromotionBanner = exports.selectMonitoringDiscountText = exports.selectEvergreenPromoOverrideDiscountText = exports.selectActivePromoOverrideDiscountText = exports.selectCurrentPromoOverrideDiscountText = exports.selectActivePromoDiscountTextWithOverrides = exports.selectCurrentPromoDiscountTextWithOverrides = exports.selectEvergreenPromoWithMonitoringDiscountText = exports.selectEvergreenPromoDiscountText = exports.selectActivePromoWithMonitoringDiscountText = exports.selectCurrentPromoWithMonitoringDiscountText = exports.selectActivePromoDiscountText = exports.selectCurrentPromoDiscountText = exports.selectActivePromoStartTime = exports.selectCurrentPromoStartTime = exports.selectActivePromoEndTime = exports.selectCurrentPromoEndTime = exports.selectEvergreenPromoWithMonitoring = exports.selectActivePromoWithMonitoring = exports.selectEvergreenPromotion = exports.selectActivePromo = exports.selectEvergreenPromoDynamicDiscountCodes = exports.selectActivePromoDynamicDiscountCodes = void 0;
const findFirstJust_1 = __importDefault(require("@simplisafe/ewok/monet-utils/findFirstJust"));
const verifyMaybe_1 = __importDefault(require("@simplisafe/ewok/monet-utils/verifyMaybe"));
const verifyMaybeObj_1 = __importDefault(require("@simplisafe/ewok/monet-utils/verifyMaybeObj"));
const isNotEmpty_1 = __importDefault(require("@simplisafe/ewok/ramda-adjunct/isNotEmpty"));
const isNotNil_1 = __importDefault(require("@simplisafe/ewok/ramda-adjunct/isNotNil"));
const monda_1 = require("@simplisafe/monda");
const chain_1 = require("@simplisafe/monda/chain");
const isAfter_1 = __importDefault(require("date-fns/isAfter"));
const monet_1 = require("monet");
const add_1 = __importDefault(require("ramda/src/add"));
const all_1 = __importDefault(require("ramda/src/all"));
const always_1 = __importDefault(require("ramda/src/always"));
const any_1 = __importDefault(require("ramda/src/any"));
const contains_1 = __importDefault(require("ramda/src/contains"));
const equals_1 = __importDefault(require("ramda/src/equals"));
const groupBy_1 = __importDefault(require("ramda/src/groupBy"));
const ifElse_1 = __importDefault(require("ramda/src/ifElse"));
const isEmpty_1 = __importDefault(require("ramda/src/isEmpty"));
const isNil_1 = __importDefault(require("ramda/src/isNil"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const propEq_1 = __importDefault(require("ramda/src/propEq"));
const propOr_1 = __importDefault(require("ramda/src/propOr"));
const reduce_1 = __importDefault(require("ramda/src/reduce"));
const reject_1 = __importDefault(require("ramda/src/reject"));
const values_1 = __importDefault(require("ramda/src/values"));
const cart_1 = require("../commercetools/cart");
const discounts_1 = require("../commercetools/discounts");
const utils_1 = require("../commercetools/utils");
const constants_1 = require("../constants");
const actions_1 = require("../deprecated/minicart/actions");
const select_1 = require("../promotions/select");
const RemoteData_1 = require("../RemoteData");
const errorLogging_1 = require("../thirdparty/errorLogging");
const policedata_1 = require("../ukPoliceData/policedata");
const date_1 = require("../utils/date");
const state_1 = require("./state");
/**
 * This takes the static "Maybe" objects stored in redux and turns them back into valid prototypes with methods.
 */
function validatePackageMonads(p) {
    return {
        ...p,
        absoluteDiscount: (0, verifyMaybe_1.default)(p.absoluteDiscount),
        absoluteDiscountWithServicePlan: (0, verifyMaybe_1.default)(p.absoluteDiscountWithServicePlan),
        discountedPrice: (0, verifyMaybe_1.default)(p.discountedPrice),
        discountedPriceWithServicePlan: (0, verifyMaybe_1.default)(p.discountedPriceWithServicePlan),
        relativeDiscount: (0, verifyMaybe_1.default)(p.relativeDiscount),
        relativeDiscountWithServicePlan: (0, verifyMaybe_1.default)(p.relativeDiscountWithServicePlan)
    };
}
/**
 * This takes the static "Maybe" objects stored in redux and turns them back into valid prototypes with methods.
 */
function validateProductMonads(p) {
    return {
        ...p,
        discountedPrice: (0, verifyMaybe_1.default)(p.discountedPrice),
        discountedPriceWithServicePlan: (0, verifyMaybe_1.default)(p.discountedPriceWithServicePlan),
    };
}
const selectNavigationProductCategory = (state) => state.get(state_1.stateKeys.navigationProductCategory).value;
exports.selectNavigationProductCategory = selectNavigationProductCategory;
/**
   * Select a product by sku.
   *
   * @example
   * const product = useSelector(selectProduct('SSPP1'))
   *
   * product.cata(renderError, renderProduct)
   */
const selectProduct = (sku, reportError = true) => (state) => {
    const products = state.get('products');
    const validatedSku = (0, utils_1.nonEmptySku)(sku);
    const product = monet_1.Maybe.fromUndefined(products)
        .chain((0, monda_1.safeProp)('value'))
        .chain(x => x.get ? monet_1.Maybe.fromUndefined(x.get(validatedSku)) : (0, monet_1.None)())
        .map(validateProductMonads)
        .toEither(Error(`PRODUCT_MISSING: ${validatedSku} could not be found in Redux state`));
    const { loading } = products;
    product.leftMap(e => {
        !loading && reportError && (0, errorLogging_1.logError)(e);
        return e;
    });
    return product;
};
exports.selectProduct = selectProduct;
/**
   * Select a product by Maybe<sku>.
   *
   * Lifts selectProduct to accept Maybe<sku> and returns Maybe<Product> instead of Either<Error, Product>.
   *
   * @example
   * const product = useSelector(liftSelectProduct(Just('SSPP1')))
   *
   * product.cata(renderEmpty, renderProduct)
   */
const liftSelectProduct = (sku, reportError = true) => (state) => sku
    .toEither(Error('SKU was not provided'))
    .chain(_sku => (0, exports.selectProduct)(_sku, reportError)(state));
exports.liftSelectProduct = liftSelectProduct;
/**
   * Select products by sku. If not all skus are found, returns a Left value with an error.
   *
   * @example
   * const products = useSelector(selectProducts([ 'SSPP1', 'SSES3' ]))
   *
   * products.cata(renderError, renderProducts)
   */
const selectProducts = (skus, reportError = true) => (state) => {
    const products = state.get('products');
    const productValues = skus
        .filter(utils_1.nonEmptySku)
        .filter(isNotEmpty_1.default)
        .map(sku => {
        return monet_1.Maybe.fromUndefined(products)
            .chain((0, monda_1.safeProp)('value'))
            .chain(x => x.get ? monet_1.Maybe.fromUndefined(x.get(sku)) : (0, monet_1.None)())
            .map(validateProductMonads)
            .toEither(Error(`PRODUCT_MISSING: ${sku} could not be found in Redux state`));
    });
    // flip the Array<Either> into Either<Array>
    const EitherListOrError = monet_1.List.fromArray(productValues)
        .sequenceEither()
        .map(_list => _list.toArray());
    const { loading } = products;
    EitherListOrError.leftMap(e => {
        !loading && reportError && (0, errorLogging_1.logError)(e);
        return e;
    });
    return EitherListOrError;
};
exports.selectProducts = selectProducts;
const selectHiddenProductSkus = (state) => monet_1.Maybe.fromUndefined(state.get('products'))
    .chain((0, monda_1.safeProp)('value'))
    .map(products => products.valueSeq()
    .filter(product => !!!(0, prop_1.default)('isViewable', product))
    .map((0, monda_1.safeProp)('masterSku'))
    .filter(x => x.isSome())
    .map(x => x.just())
    .toArray())
    .getOrElse([]);
exports.selectHiddenProductSkus = selectHiddenProductSkus;
/**
   * Select a package by sku.
   *
   * @example
   * const package = useSelector(selectPackage('SSPP1'))
   *
   * package.cata(renderError, renderPackage)
   */
const selectPackage = (sku, reportError = true) => (state) => {
    const packages = state.get('packages');
    const validatedSku = (0, utils_1.nonEmptySku)(sku);
    const packageValue = monet_1.Maybe.fromUndefined(packages).chain((0, monda_1.safeProp)('value'))
        .chain(x => x.get ? monet_1.Maybe.fromUndefined(x.get(validatedSku)) : (0, monet_1.None)())
        .map(validatePackageMonads)
        .toEither(Error(`PACKAGE_MISSING: ${validatedSku} could not be found in Redux state`));
    const { loading } = packages;
    packageValue.leftMap(e => {
        !loading && reportError && (0, errorLogging_1.logError)(e);
        return e;
    });
    return packageValue;
};
exports.selectPackage = selectPackage;
/**
   * Select a package by Maybe<sku>.
   *
   * Lifts selectPackage to accept Maybe<sku> and returns Maybe<Package> instead of Either<Error, Package>.
   *
   * @example
   * const package = useSelector(liftSelectPackage(Just('SSPP1')))
   *
   * product.cata(renderEmpty, renderPackage)
   */
const liftSelectPackage = (sku, reportError = true) => (state) => sku
    .toEither(Error('SKU was not provided'))
    .chain(_sku => (0, exports.selectPackage)(_sku, reportError)(state));
exports.liftSelectPackage = liftSelectPackage;
const selectAllPackageSkus = (state) => {
    const packages = state.get('packages');
    return packages.value.keySeq().toArray();
};
exports.selectAllPackageSkus = selectAllPackageSkus;
/**
 * Select the array of line items from the minicart. Used on pages like
 * BMS that don't make a minicart api call that can result in an error state.
 *
 * @example
 * const miniCartLineItems = useSelector(selectMiniCart)
 *
 * miniCartLineItems.map(renderMiniCartLineItem)
 */
const selectMiniCartLineItems = (state) => {
    const miniCart = state.get('minicart');
    return (0, monda_1.safeProp)('value', miniCart)
        .map(values_1.default)
        .orSome([]);
};
exports.selectMiniCartLineItems = selectMiniCartLineItems;
/**
 * Select discount values for packages.
 *
 * @example
 * const packageDiscountValues = useSelector(selectPackageDiscountValues()) // Returns discount values without Interactive monitoring plan
 *
 * const packageDiscountValues = useSelector(selectPackageDiscountValues(With Plan)) // Returns discount values with Interactive monitoring plan
 *
 * const packageDiscountValues = useSelector(selectPackageDiscountValues(No Plan)) // Returns discount values without a monitoring plan
 *
 * const packageDiscountValues = useSelector(selectPackageDiscountValues(SS2 Upgrade)) // Returns discount value of 50% with a monitoirng plan with SS2 upgrade packages
 */
const selectPackageDiscountValues = (monitoringPlan, increaseSS2UpgradeDiscount) => (state) => {
    const planKey = monitoringPlan || 'With Plan';
    const withPlanKey = (monitoringPlan === 'With Plan');
    const promoValues = withPlanKey ? (0, select_1.selectCurrentPromotionWithMonitoring)(state) : (0, select_1.selectCurrentPromotion)(state);
    const ss2UpgradeValue = increaseSS2UpgradeDiscount ? 60 : 50;
    return promoValues.cata(() => undefined, promo => {
        return (0, ifElse_1.default)((0, equals_1.default)('SS2 Upgrade'), (0, always_1.default)({
            absoluteDiscount: (0, monet_1.None)(),
            relativeDiscount: (0, monet_1.Just)(ss2UpgradeValue)
        }), (0, always_1.default)({
            absoluteDiscount: promo.absoluteDiscount,
            relativeDiscount: promo.relativeDiscount
        }))(planKey);
    });
};
exports.selectPackageDiscountValues = selectPackageDiscountValues;
/**
 * Select total prices for BMS. Returns a price either with a discount or total without a discount if discount values are not passed in.
 * @example
 * const customSystemTotalPrice = useSelector(selectCustomSystemTotalPrice('package-sku')) // Returns price value
 *
 * @example
 * const customSystemTotalPrice = useSelector(selectCustomSystemTotalPrice('package-sku', false)) // Returns price value excluding base products total price
 */
const selectCustomSystemTotalPrice = (sku, includeBaseTotalPrice, discountValues, freeLineItem) => (state) => {
    const filterPackageProducts = (_package) => (0, propOr_1.default)([], 'products', _package)
        .filter((product) => {
        const productSku = (0, propOr_1.default)('', 'sku', product);
        return freeLineItem && !freeLineItem.includes(productSku);
    });
    const basePackageFullPrice = (0, exports.selectPackage)(sku)(state);
    const basePackageModifiedPrice = (0, exports.selectPackage)(sku)(state)
        .map(_package => ({
        ..._package,
        products: filterPackageProducts(_package)
    }));
    const basePackage = freeLineItem ? basePackageModifiedPrice : basePackageFullPrice;
    const includeBaseProductsTotalPrice = (0, isNotNil_1.default)(includeBaseTotalPrice) ? includeBaseTotalPrice : true;
    // total price for base products in a custom package
    const baseProductsTotalPrice = (0, actions_1.customSystemBaseProductsPrice)(state, basePackage, discountValues);
    // total price for sensors added to a custom package (Excludes total for base prodducts)
    const addOnsTotalPrice = (0, actions_1.customSystemAddOnsTotalPrice)(state, discountValues);
    // a sum of base products price and minicart total price
    const baseProductsAndMiniCarttotalPrice = addOnsTotalPrice
        .ap(baseProductsTotalPrice.toMaybe()
        .map(n => (0, add_1.default)(n)))
        .map((0, discounts_1.getAbsoluteDiscountedPrice)(discountValues));
    // total price for custom package
    return includeBaseProductsTotalPrice ? baseProductsAndMiniCarttotalPrice : addOnsTotalPrice.map((0, discounts_1.getAbsoluteDiscountedPrice)(discountValues));
};
exports.selectCustomSystemTotalPrice = selectCustomSystemTotalPrice;
/**
 * Select total price for BMS with a discount if there is a system discount offered on the website
 * @example
 * const customSystemDiscountedPrice = useSelector(selectCustomSystemDiscountedPrice('package-sku')) // Returns discounted price without monitoring plan
 *
 * @example
 * const customSystemDiscountedPrice = useSelector(selectCustomSystemDiscountedPrice('package-sku', 'With Plan')) // Returns discounted price with monitoring plan
 *
 * @example
 * const customSystemDiscountedPrice = useSelector(selectCustomSystemDiscountedPrice('package-sku', 'With Plan', false)) // Returns discounted price with monitoring plan that excludes price for base products
 *
 * @example
 * const customSystemDiscountedPrice = useSelector(selectCustomSystemDiscountedPrice('package-sku', 'With Plan', true, system-components))
 * Returns discounted price with monitoring plan that excludes items that should be marked as free
 */
const selectCustomSystemDiscountedPrice = (sku, radioKey, includeBaseTotalPrice, freeLineItem, increaseSS2UpgradeDiscount) => (state) => {
    const discountValues = (0, exports.selectPackageDiscountValues)(radioKey, increaseSS2UpgradeDiscount)(state);
    return (0, exports.selectCustomSystemTotalPrice)(sku, includeBaseTotalPrice, discountValues, freeLineItem)(state);
};
exports.selectCustomSystemDiscountedPrice = selectCustomSystemDiscountedPrice;
/**
 * Select the array of line items from the minicart as a RemoteData object
 * with error and loading state. Used on the dynamic package pages in order
 * to handle loading and error states.
 *
 * @example
 * const miniCart = useSelector(selectMiniCartState)
 *
 * miniCart.cata(renderLoading, renderError, renderNone, renderMiniCart)
 */
const selectMiniCart = (state) => {
    const miniCart = state.get('minicart');
    const lineItems = (0, exports.selectMiniCartLineItems)(state);
    const rdMiniCart = (0, RemoteData_1.RemoteData)({
        error: (0, verifyMaybe_1.default)(miniCart.error),
        loading: miniCart.loading,
        value: (0, monda_1.fromEmpty)(lineItems)
    });
    rdMiniCart.mapError(e => {
        !miniCart.loading && (0, errorLogging_1.logError)(e);
        return e;
    });
    return rdMiniCart;
};
exports.selectMiniCart = selectMiniCart;
/**
   * Select the cart.
   *
   * @example
   * const cart = useSelector(selectCart) // => RemoteData Cart
   *
   * cart.cata(renderError, renderLoading, renderNoCart, renderCart)
   */
const selectCart = (state) => {
    const cart = state.get('cart');
    return (0, RemoteData_1.RemoteData)({
        error: (0, verifyMaybe_1.default)(cart.error),
        loading: cart.loading,
        value: (0, verifyMaybe_1.default)(cart.value)
    });
};
exports.selectCart = selectCart;
/**
   * Select the cart line item count.
   *
   * @example
   * const cartItemCount = useSelector(selectCartCount) // => number
   */
const selectCartCount = (state) => {
    const filterOutServicePlans = (lineItems) => (0, reject_1.default)((0, propEq_1.default)('productType', 'service'), lineItems);
    const cart = (0, exports.selectCart)(state);
    const cartLineItems = (0, cart_1.getCartDetails)((0, exports.selectHiddenProductSkus)(state))(cart.toMaybe()
        .map((0, prop_1.default)('lineItems'))
        .map(filterOutServicePlans)
        .getOrElse([]));
    return (0, reduce_1.default)((acc, lineItem) => acc + lineItem.quantity, 0)(cartLineItems);
};
exports.selectCartCount = selectCartCount;
/**
 * Select the cart id.
 *
 * @example
 * const cartId = useSelector(selectCartId) // => Maybe<string>
 */
const selectCartId = (state) => (0, exports.selectCart)(state).toMaybe()
    .chain((0, monda_1.safeProp)('id'));
exports.selectCartId = selectCartId;
/**
 * Returns whether or not cart has a package in it
 *
 * @example
 * const hasPackage = useSelector(selectCartHasPackage) // => boolean
 */
const selectCartHasPackage = (state) => (0, exports.selectCart)(state).toMaybe()
    .chain((0, monda_1.safeProp)('lineItems'))
    .map((0, any_1.default)(isPackage))
    .getOrElse(false);
exports.selectCartHasPackage = selectCartHasPackage;
/**
 * Returns whether a line item is a package
 */
const isPackage = (lineItem) => (0, monda_1.safeProp)('productType', lineItem)
    .filter((0, equals_1.default)(constants_1.ProductTypes.PackageParent))
    .isSome();
/**
 * Returns whether a cart has only cameras in it
 *
 * @example
 * const hasOnlyCameras = useSelector(selectCartHasOnlyCameras) // => boolean
 */
const selectCartHasOnlyCameras = (state) => (0, exports.selectCart)(state).toMaybe()
    .chain((0, monda_1.safeProp)('lineItems'))
    .map((0, all_1.default)(isCamera))
    .getOrElse(false);
exports.selectCartHasOnlyCameras = selectCartHasOnlyCameras;
const isCamera = (lineItem) => {
    return (0, monda_1.safeProp)('sku', lineItem)
        // need a better way of determining what is a camera
        .filter(sku => (0, contains_1.default)(sku)(constants_1.cameraSkus))
        .isSome();
};
/**
 * Returns array of cart line item names or empty array
 */
const selectCartLineItemNames = (state) => {
    const locale = (0, exports.selectLocale)(state);
    return (0, exports.selectCart)(state).toMaybe()
        .chain((0, monda_1.safeProp)('lineItems'))
        .map(lineItems => 
    // @ts-ignore > for some reason LineItem.name is typed as a string
    // @ts-ignore > but the data is an object keyed by locale?
    lineItems.map(lineItem => (0, monda_1.safePath)(['name', locale], lineItem))
        .filter(name => name.isSome())
        .map(name => name.just()))
        .getOrElse([]);
};
exports.selectCartLineItemNames = selectCartLineItemNames;
/**
 * Select list of crimes data by category.
 *
 * @example
 * const crimesData = useSelector(select.selectCrimesByCategory)
 */
const getCrimeData = (crimeData, count) => {
    return {
        ...crimeData,
        count
    };
};
/**
 * To get the crimes list by category grouping for the givcen location.
 *
 * @param location
 * @returns array
 */
const selectCrimesByCategory = (location) => (state) => {
    const searchData = state.get(state_1.stateKeys.policeData).value.locations;
    const crimesByCategory = Array.isArray(searchData[location]) ? (0, groupBy_1.default)((0, prop_1.default)('category'))(searchData[location]) : [];
    const result = [];
    !(0, isEmpty_1.default)(crimesByCategory) && policedata_1.CrimeData.forEach((crimeInfo) => {
        // TODO the crime data code needs to be refactored to have sound types for the response
        // It's really hard to understand what's going on
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const categoryCrime = crimesByCategory[crimeInfo.key];
        const data = !(0, isNil_1.default)(categoryCrime) && !(0, isEmpty_1.default)(categoryCrime) && getCrimeData(crimeInfo, categoryCrime.length);
        // TODO: remove the .push and remove this eslint-disable
        // eslint-disable-next-line functional/immutable-data
        data && result.push(data);
    });
    return searchData[location] ? result : undefined;
};
exports.selectCrimesByCategory = selectCrimesByCategory;
/**
 * To get the geo location place name.
 *
 * @param state
 * @returns
 * @example
 * const myLocation = useSelector(selectGeoLocationPlace)
 */
const selectGeoLocationPlace = (state) => {
    const geoLocation = state.get(state_1.stateKeys.policeData).value.geoLocation;
    return (0, monda_1.safeProp)('features', geoLocation)
        .chain(monda_1.safeHead)
        .chain((0, monda_1.safeProp)('place_name'))
        .orJust('');
};
exports.selectGeoLocationPlace = selectGeoLocationPlace;
/**
   * Contact Form Submit Response.
   *
   * @example
   * const contactSucessResponse = useSelector(select.selectContactSubmitResponse)
   *
   */
const selectContactSubmitResponse = (state) => {
    const contactForm = state.get(state_1.stateKeys.contactForm);
    return ({
        error: contactForm.error.map(x => [x]),
        loading: contactForm.loading,
        value: (0, prop_1.default)('value', contactForm)
    });
};
exports.selectContactSubmitResponse = selectContactSubmitResponse;
/**
 * Return a display price for a package.
 * If there is a package discount, it will return that discount matching the selected monitoring plan.
 */
const selectPackageDisplayPrice = (sku, radioKey) => (state) => {
    const _package = (0, exports.selectPackage)(sku)(state).toMaybe();
    const price = _package.chain((0, monda_1.safeProp)('price'));
    const discountedPrice = _package.chain((0, chain_1.chainProp)('discountedPrice'));
    const discountedPriceWithServicePlan = _package.chain((0, chain_1.chainProp)('discountedPriceWithServicePlan'));
    /**
     * Matches the price to the selection of monitoring.
     */
    const selectedPrice = radioKey === 'With Plan'
        ? discountedPriceWithServicePlan
        : discountedPrice;
    //
    return (0, findFirstJust_1.default)([selectedPrice, price]);
};
exports.selectPackageDisplayPrice = selectPackageDisplayPrice;
/**
 *  ~Return a discounted price for the package listing page. if a promo is not active or you are a partner, return interactive monitoring otherwise return the standard discount.~
 *  ~most likely will need to be modified further for various exclusive offers~
 *
 * @deprecated use `selectPackageDisplayPrice` instead.
 *
 * Discounts for partners will have to be dynamic based on customer groups.
 */
const selectPackageListPrice = (sku, isPartner) => (state) => {
    const _package = (0, exports.selectPackage)(sku)(state).toMaybe();
    const promoActive = (0, exports.selectTopBannerVisible)(state);
    const standardDiscount = (0, select_1.selectRelativeDiscount)(state);
    const monitoringDiscount = (0, select_1.selectRelativeDiscountWithMonitoring)(state);
    return _package.chain(p => {
        const priceWithMonitoring = (p.price - (p.price * monitoringDiscount.getOrElse(0) / 100));
        const priceNoMonitoring = (p.price - (p.price * standardDiscount.getOrElse(0) / 100));
        const discount = (isPartner || !promoActive) ? monet_1.Maybe.fromUndefined(priceWithMonitoring) : monet_1.Maybe.fromUndefined(priceNoMonitoring);
        return monet_1.Maybe.fromUndefined((discount).getOrElse(p.price));
    });
};
exports.selectPackageListPrice = selectPackageListPrice;
/**
 * Returns the formatted discount without service plan amount for a package by sku.
 */
const selectPackageDiscountDisplayText = (sku) => (state) => {
    const validatedSku = (0, utils_1.nonEmptySku)(sku);
    const _package = (0, exports.selectPackage)(validatedSku)(state);
    const locale = (0, exports.selectLocale)(state);
    return _package.chain(pkg => (0, discounts_1.packageToDiscountDisplayText)(locale)(pkg).toEither());
};
exports.selectPackageDiscountDisplayText = selectPackageDiscountDisplayText;
/**
 * Returns the formatted discount with service plan amount for a package by sku.
 */
const selectPackageDiscountWithMonitoringDisplayText = (sku) => (state) => {
    const validatedSku = (0, utils_1.nonEmptySku)(sku);
    const _package = (0, exports.selectPackage)(validatedSku)(state);
    const locale = (0, exports.selectLocale)(state);
    return _package.chain(pkg => (0, discounts_1.packageToDiscountWithMonitoringDisplayText)(locale)(pkg).toEither());
};
exports.selectPackageDiscountWithMonitoringDisplayText = selectPackageDiscountWithMonitoringDisplayText;
/**
 * Return promo discount display text, if available, based on first package found with promo discount data
 */
const selectPackagesDiscountDisplayText = (state) => {
    const locale = (0, exports.selectLocale)(state);
    return selectFirstPackageWithDiscount(state)
        .chain((0, discounts_1.packageToDiscountDisplayText)(locale));
};
exports.selectPackagesDiscountDisplayText = selectPackagesDiscountDisplayText;
/**
 * Return first package found with promo discount data, if available
 */
const selectFirstPackageWithDiscount = (state) => monet_1.Maybe.fromUndefined(state.get('packages'))
    .chain((0, monda_1.safeProp)('value'))
    .chain(packageMap => packageMap.isEmpty() ? (0, monet_1.None)() : (0, monet_1.Just)(packageMap.valueSeq().toArray()))
    .chain((0, monda_1.safeFind)(val => {
    const _package = validatePackageMonads(val);
    return (0, findFirstJust_1.default)([_package.absoluteDiscount, _package.relativeDiscount]).isSome();
}))
    .map(validatePackageMonads);
/**
 * Select the current locale.
 *
 * @example
 * const locale = useSelector(selectLocale) // => Locale
 */
const selectLocale = (state) => state.get(state_1.stateKeys.locale).locale;
exports.selectLocale = selectLocale;
/**
 * Select the current currency code.
 *
 * @example
 * const currencyCode = useSelector(selectCurrencyCode) // => CurrencyCode
 */
const selectCurrencyCode = (state) => state.get(state_1.stateKeys.locale).currencyCode;
exports.selectCurrencyCode = selectCurrencyCode;
const selectIsActivePromotion = (state) => {
    const { value } = state.get('currentPromotion');
    return !value.chain((0, chain_1.chainProp)('isEvergreen')).getOrElse(true);
};
exports.selectIsActivePromotion = selectIsActivePromotion;
/**
 * Exported for testing.
 * Selects the currentPromotion from state and verifies its Maybe methods are intact.
 */
const selectParsedCurrentPromotion = (state) => {
    const { value, loading } = state.get('currentPromotion');
    const promotion = (0, verifyMaybeObj_1.default)(value)
        .chain(currentPromotion => {
        // ensure that when falling back to a build-time active promotion, the promo has not expired yet
        const promoExpired = (0, chain_1.chainProp)('endTime', currentPromotion)
            .map(_endTime => (0, isAfter_1.default)((0, date_1.getCurrentTimestamp)(), new Date(_endTime)))
            .orJust(false);
        return promoExpired ? (0, monet_1.None)() : (0, monet_1.Just)(currentPromotion);
    })
        .map(currentPromotion => ({
        ...currentPromotion,
        // promoBanner and promoFlag are Maybe objects with keys that are Maybe values.
        heroStickerImage: (0, verifyMaybeObj_1.default)(currentPromotion.heroStickerImage),
        mobileBannerImage: (0, verifyMaybeObj_1.default)(currentPromotion.mobileBannerImage),
        overrideDiscountText: (0, verifyMaybeObj_1.default)(currentPromotion.overrideDiscountText),
        promoBanner: (0, verifyMaybeObj_1.default)(currentPromotion.promoBanner),
        promoFlag: (0, verifyMaybeObj_1.default)(currentPromotion.promoFlag)
    }));
    return loading ? (0, monet_1.None)() : promotion;
};
exports.selectParsedCurrentPromotion = selectParsedCurrentPromotion;
/**
 * Exported for testing.
 * Selects the activePromotion from state and verifies its Maybe methods are intact.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectParsedActivePromotion = (state) => {
    const { value, loading } = state.get('activePromotion');
    const promotion = (0, verifyMaybeObj_1.default)(value)
        .chain(activePromotion => {
        // ensure that when falling back to a build-time active promotion, the promo has not expired yet
        const promoExpired = (0, chain_1.chainProp)('endTime', activePromotion)
            .map(_endTime => (0, isAfter_1.default)((0, date_1.getCurrentTimestamp)(), new Date(_endTime)))
            .orJust(false);
        return promoExpired ? (0, monet_1.None)() : (0, monet_1.Just)(activePromotion);
    })
        .map(activePromotion => ({
        ...activePromotion,
        // promoBanner and promoFlag are Maybe objects with keys that are Maybe values.
        heroStickerImage: (0, verifyMaybeObj_1.default)(activePromotion.heroStickerImage),
        mobileBannerImage: (0, verifyMaybeObj_1.default)(activePromotion.mobileBannerImage),
        overrideDiscountText: (0, verifyMaybeObj_1.default)(activePromotion.overrideDiscountText),
        promoBanner: (0, verifyMaybeObj_1.default)(activePromotion.promoBanner),
        promoFlag: (0, verifyMaybeObj_1.default)(activePromotion.promoFlag)
    }));
    return loading ? (0, monet_1.None)() : promotion;
};
exports.selectParsedActivePromotion = selectParsedActivePromotion;
/**
 * Exported for testing.
 * Selects the evergreenPromotion from state and verifies its Maybe methods are intact.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectParsedEvergreenPromotion = (state) => {
    const { value, loading } = state.get('evergreenPromotion');
    const promotion = (0, verifyMaybeObj_1.default)(value)
        .map(evergreenPromotion => ({
        ...evergreenPromotion,
        // promoBanner and promoFlag are Maybe objects with keys that are Maybe values.
        overrideDiscountText: (0, verifyMaybeObj_1.default)(evergreenPromotion.overrideDiscountText),
        promoBanner: (0, verifyMaybeObj_1.default)(evergreenPromotion.promoBanner),
        promoFlag: (0, verifyMaybeObj_1.default)(evergreenPromotion.promoFlag)
    }));
    return loading ? (0, monet_1.None)() : promotion;
};
exports.selectParsedEvergreenPromotion = selectParsedEvergreenPromotion;
/**
 * Checks if the top promo banner is currently visible.
 *
 * @example
 * const isPromoTopBanner = useSelector(selectCurrentPromoTopBannerVisible) // => boolean
 */
const selectCurrentPromoTopBannerVisible = (state) => (0, select_1.selectPartnerBanner)(state).isSome() ||
    (0, exports.selectIsActivePromotion)(state) ||
    (!(0, exports.selectIsActivePromotion)(state) &&
        (0, exports.selectParsedCurrentPromotion)(state)
            .chain((0, chain_1.chainProp)('promoBanner'))
            .chain((0, chain_1.chainProp)('backgroundColor'))
            .isSome());
exports.selectCurrentPromoTopBannerVisible = selectCurrentPromoTopBannerVisible;
/**
 * Checks if the top promo banner is currently visible.
 *
 * @example
 * const isPromoTopBanner = useSelector(selectTopBannerVisible) // => boolean
 *
 * @deprecated use `selectCurrentPromoTopBannerVisible` instead.
 */
const selectTopBannerVisible = (state) => (0, exports.selectParsedActivePromotion)(state).isSome() ||
    (0, select_1.selectPartnerBanner)(state).isSome() ||
    ((0, exports.selectParsedActivePromotion)(state).isNone() &&
        (0, exports.selectParsedEvergreenPromotion)(state)
            .chain((0, chain_1.chainProp)('promoBanner'))
            .chain((0, chain_1.chainProp)('backgroundColor'))
            .isSome());
exports.selectTopBannerVisible = selectTopBannerVisible;
/**
 * Selects a text to display a number of free months of service a customer can get.
 * Eventually, state value should be updated based on a customer group.
 * The default: a customer gets one free month.
 * Text will be used in the promo banners and Buy Box titles on Package pages
 *
 * @deprecated use `selectMonthsOfServiceDisplay` instead.
 */
const selectMonthsOfFreeService = (state) => {
    const numberFreeMonthsOfService = state.get(state_1.stateKeys.numberOfFreeMonthsOfService).value;
    return numberFreeMonthsOfService > 1 ? `${numberFreeMonthsOfService} free months` : 'free month';
};
exports.selectMonthsOfFreeService = selectMonthsOfFreeService;
/**
* Selects a text to display a number of months of service a customer can get for free.
* Eventually, state value should be updated based on a customer group.
* The default: a customer gets one free month.
* Text will be used in the service plan description in the Buy Box on package pages
*
* @deprecated use `selectMonthsOfServiceDisplay` instead.
*/
const selectMonthsOfService = (state) => {
    const numberFreeMonthsOfService = state.get(state_1.stateKeys.numberOfFreeMonthsOfService).value;
    return numberFreeMonthsOfService > 1 ? `${numberFreeMonthsOfService} months are` : 'month is';
};
exports.selectMonthsOfService = selectMonthsOfService;
/**
 * Returns a text to display a number of free months of service a customer can get.
 * This is a quick solution for the partners migration launch.
 * Eventually number of free months for monitoring we display will be based on a service plan added to cart
 * (for non-partner visitors, it will default to 1, as they will not have a cart created on initial website visit)
 * Text will be used in the promo banners and Buy Box titles on Package pages
 *
 * @param serviceDurationOnly
 *  - If true, return only a copy with a number of free months (example: "free month" or "2 free months")
 *  - if false, return months of service copy to display in a sentence (example: "month is" or "months are")
 * @param partnerGroup Partner group name
 *
 * const monthsOfService = useSelector(selectMonthsOfServiceDisplay(true, "standard-partner")) // => if promo is active: "2 free months", if promo is inactive: "free month"
 *
 * const monthsOfService = useSelector(selectMonthsOfServiceDisplay(false)) // => "month is"
 *
 */
const selectMonthsOfServiceDisplay = (serviceDurationOnly, partnerGroup = '') => (state) => {
    const isStandardPartner = partnerGroup === 'standard-partner';
    const isStrategicReferralPartner = partnerGroup === 'partner-strategic-referral';
    const isActivePromo = (0, exports.selectIsActivePromotion)(state);
    const numberFreeMonthsOfService = (isStrategicReferralPartner || (isActivePromo && isStandardPartner)) ? 2 : 1;
    const oneMonthCopy = serviceDurationOnly ? 'free month' : 'month is';
    const multipleMonthsCopy = serviceDurationOnly ? `${oneMonthCopy}s` : 'months are';
    return numberFreeMonthsOfService > 1 ? `${numberFreeMonthsOfService} ${multipleMonthsCopy}` : oneMonthCopy;
};
exports.selectMonthsOfServiceDisplay = selectMonthsOfServiceDisplay;
/**
 * Selects the current promo code from redux.
 * If there is no active promo code it will return the evergreen promo code.
 */
const selectCurrentPromoCode = (state) => (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('promoCode'));
exports.selectCurrentPromoCode = selectCurrentPromoCode;
/**
 * Selects the active promo code from redux.
 * If there is no active promo code it will return the evergreen promo code.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoCode = (state) => (0, exports.selectParsedActivePromotion)(state).chain((0, chain_1.chainProp)('promoCode'));
exports.selectActivePromoCode = selectActivePromoCode;
/**
 * Selects the partner promo code from redux.
 * If there is no partner promo code it will return undefined.
 */
const selectPartnerPromoCodes = (state) => (0, select_1.selectPartnerBanner)(state).chain((0, chain_1.chainProp)('partnerPromoCodes'));
exports.selectPartnerPromoCodes = selectPartnerPromoCodes;
/**
 * Selects the evergreen promo code from redux
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromoCode = (state) => (0, exports.selectParsedEvergreenPromotion)(state).chain((0, chain_1.chainProp)('promoCode'));
exports.selectEvergreenPromoCode = selectEvergreenPromoCode;
const selectCurrentPromoVariationId = (state) => (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('variationId'));
exports.selectCurrentPromoVariationId = selectCurrentPromoVariationId;
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoVariationId = (state) => (0, exports.selectParsedActivePromotion)(state).chain((0, chain_1.chainProp)('variationId'));
exports.selectActivePromoVariationId = selectActivePromoVariationId;
/**
 * Selects the current promo flag colors.
 */
const selectCurrentPromoFlag = (state) => (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('promoFlag'));
exports.selectCurrentPromoFlag = selectCurrentPromoFlag;
/**
 * Selects the active promo flag colors.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoFlag = (state) => (0, exports.selectParsedActivePromotion)(state).chain((0, chain_1.chainProp)('promoFlag'))
    .catchMap(() => (0, select_1.selectEvergreenPromo)(state).chain((0, chain_1.chainProp)('promoFlag')));
exports.selectActivePromoFlag = selectActivePromoFlag;
const selectCurrentPromoCodeWithMonitoring = (state) => (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('promoCodeWithMonitoring'));
exports.selectCurrentPromoCodeWithMonitoring = selectCurrentPromoCodeWithMonitoring;
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoCodeWithMonitoring = (state) => (0, exports.selectParsedActivePromotion)(state).chain((0, chain_1.chainProp)('promoCodeWithMonitoring'));
exports.selectActivePromoCodeWithMonitoring = selectActivePromoCodeWithMonitoring;
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromoCodeWithMonitoring = (state) => (0, exports.selectParsedEvergreenPromotion)(state).chain((0, chain_1.chainProp)('promoCodeWithMonitoring'));
exports.selectEvergreenPromoCodeWithMonitoring = selectEvergreenPromoCodeWithMonitoring;
const selectCurrentPromoDynamicDiscountCodes = (state) => (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('promoDynamicDiscountCodes'));
exports.selectCurrentPromoDynamicDiscountCodes = selectCurrentPromoDynamicDiscountCodes;
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoDynamicDiscountCodes = (state) => (0, exports.selectParsedActivePromotion)(state).chain((0, chain_1.chainProp)('promoDynamicDiscountCodes'));
exports.selectActivePromoDynamicDiscountCodes = selectActivePromoDynamicDiscountCodes;
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromoDynamicDiscountCodes = (state) => (0, exports.selectParsedEvergreenPromotion)(state).chain((0, chain_1.chainProp)('promoDynamicDiscountCodes'));
exports.selectEvergreenPromoDynamicDiscountCodes = selectEvergreenPromoDynamicDiscountCodes;
/**
 * Returns the Promo object of the active promotion.
 *
 * @private - not intended for use outside of ecomm-data
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromo = (state) => {
    const promoCode = (0, exports.selectActivePromoCode)(state);
    const promotions = (0, select_1.selectPromotions)(state);
    return promoCode.chain(code => monet_1.Maybe.fromUndefined(promotions.get(code)));
};
exports.selectActivePromo = selectActivePromo;
/**
 * Returns the Promo object of the evergreen promotion.
 * Has to be named differently than selectEvergreenPromo in ../promotions
 *
 * @private - not intended for use outside of ecomm-data.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromotion = (state) => {
    const promoCode = (0, exports.selectEvergreenPromoCode)(state);
    const promotions = (0, select_1.selectPromotions)(state);
    return promoCode.chain(code => monet_1.Maybe.fromUndefined(promotions.get(code)));
};
exports.selectEvergreenPromotion = selectEvergreenPromotion;
/**
* Returns the Promo object of the active promotion with monitoring.
*
* @private - not intended for use outside of ecomm-data.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
*/
const selectActivePromoWithMonitoring = (state) => {
    const promoCode = (0, exports.selectActivePromoCodeWithMonitoring)(state);
    return (0, select_1.selectPromotionByCode)(state)(promoCode);
};
exports.selectActivePromoWithMonitoring = selectActivePromoWithMonitoring;
/**
 * Returns the Promo object of the evergreen promotion with monitoring.
 *
 * @private - not intended for use outside of ecomm-data.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromoWithMonitoring = (state) => {
    const promoCode = (0, exports.selectEvergreenPromoCodeWithMonitoring)(state);
    return (0, select_1.selectPromotionByCode)(state)(promoCode);
};
exports.selectEvergreenPromoWithMonitoring = selectEvergreenPromoWithMonitoring;
/**
 * Returns the end time of the current promo as an ISO string.
 */
const selectCurrentPromoEndTime = (state) => (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('endTime'));
exports.selectCurrentPromoEndTime = selectCurrentPromoEndTime;
/**
 * Returns the end time of the active promo as an ISO string.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoEndTime = (state) => (0, exports.selectParsedActivePromotion)(state).isSome() ?
    (0, exports.selectParsedActivePromotion)(state).chain((0, chain_1.chainProp)('endTime')) :
    (0, exports.selectParsedEvergreenPromotion)(state).chain((0, chain_1.chainProp)('endTime'));
exports.selectActivePromoEndTime = selectActivePromoEndTime;
/**
 * Returns the start time of the active promo as an ISO string.
 */
const selectCurrentPromoStartTime = (state) => (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('startTime'));
exports.selectCurrentPromoStartTime = selectCurrentPromoStartTime;
/**
 * Returns the start time of the active promo as an ISO string.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoStartTime = (state) => (0, exports.selectParsedActivePromotion)(state).chain((0, chain_1.chainProp)('startTime'));
exports.selectActivePromoStartTime = selectActivePromoStartTime;
/**
 * Returns the discount text of the active promo.
 */
const selectCurrentPromoDiscountText = (state) => {
    const { locale } = state.get(state_1.stateKeys.locale);
    return (0, select_1.selectCurrentPromotion)(state).chain((0, discounts_1.promoCodeToDiscountDisplayText)(locale));
};
exports.selectCurrentPromoDiscountText = selectCurrentPromoDiscountText;
/**
 * Returns the discount text of the active promo.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoDiscountText = (state) => {
    const { locale } = state.get(state_1.stateKeys.locale);
    return (0, exports.selectActivePromo)(state).chain((0, discounts_1.promoCodeToDiscountDisplayText)(locale));
};
exports.selectActivePromoDiscountText = selectActivePromoDiscountText;
const selectCurrentPromoWithMonitoringDiscountText = (state) => {
    const { locale } = state.get(state_1.stateKeys.locale);
    return (0, select_1.selectCurrentPromotionWithMonitoring)(state).chain((0, discounts_1.promoCodeToDiscountDisplayText)(locale));
};
exports.selectCurrentPromoWithMonitoringDiscountText = selectCurrentPromoWithMonitoringDiscountText;
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoWithMonitoringDiscountText = (state) => {
    const { locale } = state.get(state_1.stateKeys.locale);
    return (0, exports.selectActivePromoWithMonitoring)(state).chain((0, discounts_1.promoCodeToDiscountDisplayText)(locale));
};
exports.selectActivePromoWithMonitoringDiscountText = selectActivePromoWithMonitoringDiscountText;
/**
 * Returns the discount text of the evergreen promo.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromoDiscountText = (state) => {
    const { locale } = state.get(state_1.stateKeys.locale);
    return (0, exports.selectEvergreenPromotion)(state).chain((0, discounts_1.promoCodeToDiscountDisplayText)(locale));
};
exports.selectEvergreenPromoDiscountText = selectEvergreenPromoDiscountText;
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromoWithMonitoringDiscountText = (state) => {
    const { locale } = state.get(state_1.stateKeys.locale);
    return (0, exports.selectEvergreenPromoWithMonitoring)(state).chain((0, discounts_1.promoCodeToDiscountDisplayText)(locale));
};
exports.selectEvergreenPromoWithMonitoringDiscountText = selectEvergreenPromoWithMonitoringDiscountText;
/**
 * Returns the discount text accounting for the displayMonitoringDiscount override toggle.
 */
const selectCurrentPromoDiscountTextWithOverrides = (state) => {
    const displayMonitoringDiscount = (0, exports.selectCurrentPromoDisplayMonitoringDiscount)(state);
    const selectPromo = displayMonitoringDiscount ? exports.selectCurrentPromoWithMonitoringDiscountText : exports.selectCurrentPromoDiscountText;
    return selectPromo(state);
};
exports.selectCurrentPromoDiscountTextWithOverrides = selectCurrentPromoDiscountTextWithOverrides;
/**
 * Returns the discount text accounting for the displayMonitoringDiscount override toggle.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoDiscountTextWithOverrides = (state) => {
    const displayMonitoringDiscount = (0, exports.selectDisplayMonitoringDiscount)(state);
    const selectPromo = (0, exports.selectParsedActivePromotion)(state).isSome() ?
        (displayMonitoringDiscount ? exports.selectActivePromoWithMonitoringDiscountText : exports.selectActivePromoDiscountText) :
        (displayMonitoringDiscount ? exports.selectEvergreenPromoWithMonitoringDiscountText : exports.selectEvergreenPromoDiscountText);
    return selectPromo(state);
};
exports.selectActivePromoDiscountTextWithOverrides = selectActivePromoDiscountTextWithOverrides;
const selectCurrentPromoOverrideDiscountText = (state) => (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('overrideDiscountText'));
exports.selectCurrentPromoOverrideDiscountText = selectCurrentPromoOverrideDiscountText;
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoOverrideDiscountText = (state) => (0, exports.selectParsedActivePromotion)(state).chain((0, chain_1.chainProp)('overrideDiscountText'));
exports.selectActivePromoOverrideDiscountText = selectActivePromoOverrideDiscountText;
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromoOverrideDiscountText = (state) => (0, exports.selectParsedEvergreenPromotion)(state).chain((0, chain_1.chainProp)('overrideDiscountText'));
exports.selectEvergreenPromoOverrideDiscountText = selectEvergreenPromoOverrideDiscountText;
/**
 * Returns the monitoring discount text for the active promo, falling back to evergreen promo.
 */
const selectMonitoringDiscountText = (state) => {
    const selectPromo = (0, exports.selectParsedActivePromotion)(state).isSome() ?
        exports.selectActivePromoWithMonitoringDiscountText : exports.selectEvergreenPromoWithMonitoringDiscountText;
    return selectPromo(state);
};
exports.selectMonitoringDiscountText = selectMonitoringDiscountText;
const selectCurrentPromotionBanner = (state) => (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('promoBanner'));
exports.selectCurrentPromotionBanner = selectCurrentPromotionBanner;
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectPromotionBanner = (state) => (0, exports.selectParsedActivePromotion)(state).isSome() ?
    (0, exports.selectParsedActivePromotion)(state).chain((0, chain_1.chainProp)('promoBanner')) :
    (0, exports.selectParsedEvergreenPromotion)(state).chain((0, chain_1.chainProp)('promoBanner'));
exports.selectPromotionBanner = selectPromotionBanner;
const selectCurrentPromoLoading = (state) => state.get('currentPromotion').loading;
exports.selectCurrentPromoLoading = selectCurrentPromoLoading;
/**
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoLoading = (state) => state.get('activePromotion').loading;
exports.selectActivePromoLoading = selectActivePromoLoading;
/**
 * Returns the last fetched time of the current promo.
 *
 * @private - not intended for use outside of ecomm-data
 */
const selectCurrentPromoLastFetchedTime = (state) => (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('lastFetched'));
exports.selectCurrentPromoLastFetchedTime = selectCurrentPromoLastFetchedTime;
/**
 * Returns the last fetched time of the active promo.
 *
 * @private - not intended for use outside of ecomm-data
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoLastFetchedTime = (state) => (0, exports.selectParsedActivePromotion)(state).chain((0, chain_1.chainProp)('lastFetched'));
exports.selectActivePromoLastFetchedTime = selectActivePromoLastFetchedTime;
/**
 * Returns the last fetched time of the evergreen promo.
 *
 * @private - not intended for use outside of ecomm-data.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromoLastFetchedTime = (state) => (0, select_1.selectEvergreenPromo)(state).chain((0, chain_1.chainProp)('lastFetched'));
exports.selectEvergreenPromoLastFetchedTime = selectEvergreenPromoLastFetchedTime;
/**
 * Returns the last fetched time of the current promo.
 *
 * @private - not intended for use outside of ecomm-data
 */
const selectCurrentPromoLastModifiedTime = (state) => (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('lastModified'));
exports.selectCurrentPromoLastModifiedTime = selectCurrentPromoLastModifiedTime;
/**
 * Returns the last fetched time of the active promo.
 *
 *  @private - not intended for use outside of ecomm-data
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectActivePromoLastModifiedTime = (state) => (0, exports.selectParsedActivePromotion)(state).chain((0, chain_1.chainProp)('lastModified'));
exports.selectActivePromoLastModifiedTime = selectActivePromoLastModifiedTime;
/**
 * Returns the last fetched time of the evergreen promo.
 *
 * @private - not intended for use outside of ecomm-data.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromoLastModifiedTime = (state) => (0, select_1.selectEvergreenPromo)(state).chain((0, chain_1.chainProp)('lastModified'));
exports.selectEvergreenPromoLastModifiedTime = selectEvergreenPromoLastModifiedTime;
/**
 * Returns current promotion displayMonitoringDiscount flag
 * @param state
 * @returns
 */
const selectCurrentPromoDisplayMonitoringDiscount = (state) => {
    return (0, exports.selectParsedCurrentPromotion)(state)
        .chain((0, monda_1.safeProp)('displayMonitoringDiscount'))
        .orJust(false);
};
exports.selectCurrentPromoDisplayMonitoringDiscount = selectCurrentPromoDisplayMonitoringDiscount;
/**
 * Returns displayMonitoringDiscount flag, if Active promotion resolves to None check the Evergreen promotion instead
 * @param state
 * @returns
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectDisplayMonitoringDiscount = (state) => {
    const activePromotion = (0, exports.selectParsedActivePromotion)(state);
    return activePromotion.catchMap(() => (0, select_1.selectEvergreenPromo)(state)).chain((0, monda_1.safeProp)('displayMonitoringDiscount'))
        .orJust(false);
};
exports.selectDisplayMonitoringDiscount = selectDisplayMonitoringDiscount;
/**
 * Selects either a package or a product with the given SKU. If neither is found, it preemptively logs an error.
 */
const selectItemFromSku = (sku) => (state) => {
    const eitherPackage = (0, exports.selectPackage)(sku, false)(state);
    const eitherProduct = (0, exports.selectProduct)(sku, false)(state);
    return eitherPackage.catchMap(() => eitherProduct.catchMap(() => (0, monet_1.Left)(new Error(`Cannot find ${sku} from product and package states`))));
};
exports.selectItemFromSku = selectItemFromSku;
const selectItemsFromSkus = (skus) => (state) => skus
    .filter(sku => !!sku)
    .map(sku => (0, exports.selectItemFromSku)(sku)(state))
    .map(item => item.toMaybe().orUndefined())
    .filter(isNotNil_1.default)
    .reduce((obj, item) => ({
    ...obj,
    [item.sku]: item
}), {});
exports.selectItemsFromSkus = selectItemsFromSkus;
/**
 * Returns true if partner-with-us form was submitted.
 */
const selectPartnerWithUsSubmit = (state) => state.get(state_1.stateKeys.partnerWithUsForm).submitted;
exports.selectPartnerWithUsSubmit = selectPartnerWithUsSubmit;
/**
 * Returns the image of the current promotion
 */
const selectCurrentPromotionMobileBannerImage = (state) => {
    return (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('mobileBannerImage'));
};
exports.selectCurrentPromotionMobileBannerImage = selectCurrentPromotionMobileBannerImage;
/**
 * Returns the heroStickerImage of the current promotion
 */
const selectHeroStickerImage = (state) => {
    return (0, exports.selectParsedCurrentPromotion)(state).chain((0, chain_1.chainProp)('heroStickerImage'));
};
exports.selectHeroStickerImage = selectHeroStickerImage;
//# sourceMappingURL=select.js.map